module.exports = __webpack_public_path__ + "img/VRCampus_mehrfarbig_RGB.233ff992.svg";